import {error} from "services-comun/modules/browser/log";

import {Controller} from "../controller";
import {EncuestasWebFrontendRequest} from "services-comun-ed/modules/services/encuestas/frontend-web";

export class MenusController extends Controller {
    /* STATIC */
    public static override async build(): Promise<void> {
        const form = document.body as HTMLElement|null;
        if (form!=null) {
            new this(form);
        }
    }

    /* INSTANCE */

    private constructor(private readonly form: HTMLElement) {
        super();

        const encabezado = form.querySelector('.c-encabezado') as HTMLElement;
        const barraSeoElement = form.querySelector('.es-noticia') as HTMLElement;
        const heightBarraSeo = barraSeoElement.clientHeight;
        let ultimoScroll = 0;

        const menu = form.querySelector('.menu') as HTMLElement;
        const abrirMenu = form.querySelector('.boton-menu') as HTMLElement;
        const cerrarMenu = form.querySelector('.cerrar-menu') as HTMLElement;

        const barraDestacadasElement = form.querySelector('.es-destacada') as HTMLElement;
        const heightbarraDestacadas = barraDestacadasElement.clientHeight;

        // Evento para fijar el scroll de la portadilla cuando se abre el menú
        abrirMenu.onclick = () => {
            form.style.overflow = 'hidden';
        }

        // Evento para habilitar el scroll de la portadilla cuando se cierra el menú
        cerrarMenu.onclick = () => {
            form.style.overflow = 'auto';
        }

        form.onscroll = (ev) => {
            let scroll = window.scrollY;
            let desp = window.pageYOffset || document.documentElement.scrollTop;
            if (desp > ultimoScroll && barraSeoElement && scroll>heightBarraSeo) {
                encabezado.classList.add('oculta');
                encabezado.classList.add('oculta-destacadas');
                menu.classList.add('desplazado')
            } else if (desp <= 0) {
                encabezado.classList.remove('oculta')
                menu.classList.remove('desplazado')
            }

            if(desp < ultimoScroll && barraDestacadasElement && scroll>heightbarraDestacadas) {
                encabezado.classList.remove('oculta-destacadas');
            }

            ultimoScroll= desp <= 0 ? 0 : desp;
        }
    }
}
